import { useEffect, useState } from "react";

/**
 * Effect that executes changes after first render and all loaders are true
 * @param callback callback function to be executed when targets change, after the first render and the loaders are all false
 * @param targets targets to watch for changes
 * @param loaders loaders that must be all false before the callback is executed on target change
 */
const useAfterInitEffect = function (callback, targets) {
  let loaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [false];
  const {
    0: skippedFirstExec,
    1: setSkippedFirstExec
  } = useState(false);
  useEffect(() => {
    if (loaders.every(isLoading => !isLoading)) {
      if (skippedFirstExec) {
        callback();
      } else {
        setSkippedFirstExec(true);
      }
    }
  }, [...targets]);
};
export default useAfterInitEffect;